import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import getFileIcon from '@hellodarwin/core/lib/components/files/utils/get-file-icon';
import { AssetEntity } from '@hellodarwin/core/lib/features/entities';
import filterFiles from '@hellodarwin/core/lib/features/helpers/filter-files';
import { getStringDate } from '@hellodarwin/core/lib/features/helpers/get-formatted-date';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Download from '@hellodarwin/icons/dist/icons/Download';
import Empty from 'antd/es/empty';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { FileTileContainer } from './styles';
import {
  SimpleFilesListBody,
  SimpleFilesListCtas,
  SimpleFilesListRow,
  SimpleFilesListSection,
} from './styles';

export interface SimpleFilesListProps {
  handleDownload: (asset: AssetEntity) => void;
  assets: AssetEntity[];
}

const SimpleFilesList = ({ handleDownload, assets }: SimpleFilesListProps) => {
  const [sortedFiles, setSortedFiles] = useState<AssetEntity[]>(assets);
  const { t } = useTranslations();
  const locale = useLocale();
  const theme = useTheme();

  useEffect(() => {
    setSortedFiles(filterFiles(assets, 'recent', 'ascending') as AssetEntity[]);
  }, [assets]);

  return (
    <SimpleFilesListCtas>
      {sortedFiles.length > 0 ? (
        sortedFiles.map((asset) => {
          const Icon = getFileIcon(asset);
          return (
            <FileTileContainer key={asset.asset_id}>
              <SimpleFilesListRow>
                <SimpleFilesListBody>
                  <Icon />
                </SimpleFilesListBody>
                <SimpleFilesListSection>
                  <Typography elementTheme="subtitle2">
                    {asset.display_name || asset.file_name}
                  </Typography>
                  {!!asset.created_at && (
                    <Typography
                      elementTheme="body3"
                      color={theme.colors.purple_2}
                      medium
                    >
                      {getStringDate(asset.created_at, locale.selectedLocale)}
                    </Typography>
                  )}
                </SimpleFilesListSection>
              </SimpleFilesListRow>
              <Button
                onClick={() => handleDownload(asset)}
                defaultStyle={theme.colors.purple_2}
                trailingIcon={<Download size={20}></Download>}
              >
                {t('grant_single|download')}
              </Button>
            </FileTileContainer>
          );
        })
      ) : (
        <Empty
          description={
            <Typography elementTheme="subtitle2" color={theme.colors.grey_2}>
              {t(`assetsUpload|no_files`)}
            </Typography>
          }
        />
      )}
    </SimpleFilesListCtas>
  );
};

export default SimpleFilesList;
